import * as ACTIONS from "./../actions/types"

// A reducer to handle loading in potential extras to add to a plan

const defaultState = {
  byDevice: [],
  byPlan: [],
  byCondition: [],
  byPlanAndDevice: [],
  byID: {}, // Sort out the devices by ID
  allIDs: []
}

const extrasReducer = (state = defaultState, { type, payload }) => {
  switch (type) {
    case ACTIONS.FETCH_EXTRAS_SUCCESS:
      return {
        ...state,
        byDevice: payload.byDevice,
        byPlan: payload.byPlan,
        byCondition: payload.byCondition,
        byPlanAndDevice: payload.byPlanAndDevice,
        byID: payload.GLOBAL_EXTRAS,
        allIDs: Object.keys(payload.GLOBAL_EXTRAS)
      }

    case ACTIONS.REPLACE_EXTRAS:
      return {
        ...state,
        byID: payload,
        allIDs: Object.keys(payload)
      }

    default:
      return state
  }
}

export default extrasReducer
